import React from "react";
import PropTypes from "prop-types";

const GMSFillButton = ({
  name = "",
  type = "button",
  disabled = false,
  fontSize = "14px",
  onClick,
  ...props
}) => {
  return (
    <div>
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className="button-fill"
      >
        {name}
      </button>
    </div>
  );
};

GMSFillButton.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default GMSFillButton;
